<template>
  <div>
    <div class="bg-dark text-white p-20px mt-10px rounded" v-if="resultsLoaded && songs.length">
      <p class="text-gray-light mt-0">Nájdené možné duplicity ({{songs.length}})</p>

      <div class="mb-5px d-flex flex-column gap-10px">
        <a :href="song.link" v-for="song in songs" class="d-flex align-items-center text-white text-decoration-none text-primary-hover">
          <UserImage :image="song.image" />
          <span class="ms-10px">{{ song.nameFull }}</span>
        </a>
      </div>
    </div>

    <p v-if="resultsLoaded && songs.length" class="text-danger mt-10px mb-0">Prosím nevytváraj duplicity, ak niekto na nájdených trakoch chýba, pridaj ho na stránke daného tracku.</p>

    <p v-if="showSuccessMessage" class="text-success my-10px">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
      </svg>
      Super, tento track ešte neevidujeme.
    </p>
  </div>
</template>

<script>
import { getSongsByName } from "../helpers/SongApi";
import UserImage from "../User/UserImage.vue";

export default {
  components: { UserImage },
  data() {
    return {
      text: '',
      loading: false,
      resultsLoaded: false,
      songs: [],
    }
  },
  watch: {
    text() {
      this.validate();
    },
  },
  computed: {
    showSuccessMessage() {
      return this.resultsLoaded && this.artist && this.name && this.songs.length < 1;
    },
  },
  methods: {
    validate() {
      this.resultsLoaded = false;

      if (this.text.length >= 2) {
        getSongsByName(this.text).then(res => {
          this.songs = res.data;
          this.resultsLoaded = true;
        });
      } else {
        this.songs = [];
        this.resultsLoaded = true;
      }
    }
  },
  mounted() {
    const nameInput = document.querySelector('input[name="name"]');
    const component = this;

    nameInput.addEventListener('keyup', function (e) {
      component.text = e.target.value;
    });
  }
}
</script>
